import { useMutation, useQueryClient } from '@tanstack/react-query'

import { unapproveInquiry } from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'

type MutationPayload = {
  inquiryId?: ParameterID
}

export function useMutationUnapproveInquiry() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['MutationUnapproveInquiry'],
    mutationFn: async ({ inquiryId }: MutationPayload) => {
      await unapproveInquiry(inquiryId ?? '')

      queryClient.invalidateQueries(['QueryGetAllInquiries'])
      queryClient.invalidateQueries(['QueryGetInquiryById', Number(inquiryId)])
    },
  })
}
